import React from 'react';
import {Grid} from '@deere/fuel-react';
import {FeedbackYesNo} from "./FeedbackYesNo";
import {FeedbackLikertScale} from "./FeedbackLikertScale";
import {FEEDBACK_TYPE_OPTIONS} from "../shared/Constants";

export const FeedbackRespType = ({
                                     control,
                                     state,
                                     item,
                                     onChange,
                                     errors
                                 }) => {
    const feedbackTypeOptions = FEEDBACK_TYPE_OPTIONS;
    const handleChange = (isSelected) => {
        onChange(item.category.id, item.id, isSelected)
    }

    const maxStars = item.responseType.id === 2 ? 5 :
        item.responseType.id === 4 ? item.custLikertRanges.length : 0;

    return (
        <Grid item xs={12}>
            {item.responseType.id === 1 && (
                <FeedbackYesNo state={state}
                               control={control}
                               options={feedbackTypeOptions}
                               onChange={handleChange}
                               criteria={item.criteria}
                               criteriaId={item.id}
                               statusValue={item.feedback.yesNoChoice}
                               commentValue={item.feedback.comment}
                               naValue={JSON.parse(item.feedback.notApplicable)}
                               errors={errors}
                />
            )}
            {(item.responseType.id === 2 || item.responseType.id === 4) && (
                <FeedbackLikertScale state={state}
                                     control={control}
                                     onChange={handleChange}
                                     criteria={item.criteria}
                                     criteriaId={item.id}
                                     item={item}
                                     ratingValue={item.feedback.rating}
                                     commentValue={item.feedback.comment}
                                     naValue={JSON.parse(item.feedback.notApplicable)}
                                     errors={errors}
                                     maxStars={maxStars}
                />
            )}
        </Grid>
    )
}
